import ArrowRight from "@material-symbols/svg-500/rounded/arrow_forward_ios.svg?react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const ArrowRightIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: ArrowRight });
	return <Icon />;
};

export default ArrowRightIcon;
